import { HayabanOsobanApi } from "@/api/HayabanOsobanApi";
import { HayabanOsoban, HayabanOsobanDetail } from "@/types/Shinsei";

export class HayabanOsobanService {

  /**
   * 早番遅番申請を登録します
   */
  public async create(req: HayabanOsoban): Promise<any> {
    const api = new HayabanOsobanApi();
    try {
      return await api.createShinsei(req);
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 早番遅番申請を登録します
   */
  public async delete(hayabanOsoban: HayabanOsoban, koyouKeiyakuTimeId: number): Promise<any> {
    const api = new HayabanOsobanApi();
    try {
      return await api.deleteShinsei(hayabanOsoban, koyouKeiyakuTimeId);
    } catch (e: any) {
      throw e
    }
  }

  /**
   * 早番遅番申請を登録します
   */
  public async getDetail(id: number): Promise<HayabanOsobanDetail> {
    const api = new HayabanOsobanApi();
    try {
      return await api.getDetail(id);
    } catch (e: any) {
      throw e
    }
  }
}
